import { Input, Select, Space, Row, Col, Typography, Card } from 'antd';
import { SearchOutlined, FilterOutlined, ShopOutlined } from '@ant-design/icons';

const { Text } = Typography;

interface ConsultoresFiltrosProps {
  isSuperAdmin: boolean;
  searchTerm: string;
  tipoFilter: string;
  statusFilter: string;
  selectedTenant: string | null;
  tenants: { id: string; nome: string }[];
  onSearchTermChange: (value: string) => void;
  onTipoFilterChange: (value: string) => void;
  onStatusFilterChange: (value: string) => void;
  onSelectedTenantChange: (value: string | null) => void;
}

export function ConsultoresFiltros({
  isSuperAdmin,
  searchTerm,
  tipoFilter,
  statusFilter,
  selectedTenant,
  tenants,
  onSearchTermChange,
  onTipoFilterChange,
  onStatusFilterChange,
  onSelectedTenantChange,
}: ConsultoresFiltrosProps) {
  return (
    <Card variant="borderless" className="shadow-sm mb-6 rounded-xl" styles={{ body: { padding: '24px' } }}>
      <Row gutter={[20, 20]} align="bottom">
        {/* Seletor de Tenant para superadmin */}
        {isSuperAdmin && (
          <Col xs={24} lg={6}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              <Space className="text-gray-500">
                <ShopOutlined />
                <Text strong>Empresa</Text>
              </Space>
              <Select
                size="large"
                style={{ width: '100%' }}
                value={selectedTenant || 'all'}
                onChange={(value) => onSelectedTenantChange(value === "all" ? null : value)}
                placeholder="Selecione uma empresa"
              >
                <Select.Option value="all">Todas as empresas</Select.Option>
                {tenants.map((tenant) => (
                  <Select.Option key={tenant.id} value={tenant.id}>
                    {tenant.nome}
                  </Select.Option>
                ))}
              </Select>
            </div>
          </Col>
        )}

        {/* Busca Principal */}
        <Col xs={24} lg={isSuperAdmin ? 8 : 12}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            <Space className="text-gray-500">
              <SearchOutlined />
              <Text strong>Pesquisa</Text>
            </Space>
            <Input
              size="large"
              placeholder="Buscar por nome, código ou email..."
              prefix={<SearchOutlined style={{ color: '#bfbfbf' }} />}
              value={searchTerm}
              onChange={(e) => onSearchTermChange(e.target.value)}
              allowClear
            />
          </div>
        </Col>

        {/* Filtro de Tipo */}
        <Col xs={24} sm={12} lg={5}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            <Space className="text-gray-500">
              <FilterOutlined />
              <Text strong>Função</Text>
            </Space>
            <Select
              size="large"
              style={{ width: '100%' }}
              value={tipoFilter}
              onChange={onTipoFilterChange}
            >
              <Select.Option value="todos">Todas as Funções</Select.Option>
              <Select.Option value="supervisor">Supervisores</Select.Option>
              <Select.Option value="lider">Líderes de Vendas</Select.Option>
              <Select.Option value="relacionador">Relacionadores</Select.Option>
              <Select.Option value="master">Masters</Select.Option>
            </Select>
          </div>
        </Col>

        {/* Filtro de Status */}
        <Col xs={24} sm={12} lg={5}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            <Space className="text-gray-500">
              <FilterOutlined />
              <Text strong>Status</Text>
            </Space>
            <Select
              size="large"
              style={{ width: '100%' }}
              value={statusFilter}
              onChange={onStatusFilterChange}
            >
              <Select.Option value="todos">Todos Status</Select.Option>
              <Select.Option value="ativo">Ativos</Select.Option>
              <Select.Option value="inativo">Inativos</Select.Option>
            </Select>
          </div>
        </Col>
      </Row>
    </Card>
  );
}